export default __webpack_public_path__ + "static/media/playicon.54ed0911.webp";